import Appointment2 from '@/components/Appointment2';
import Banner from '@/components/Banner2';
import Cases from './components/Cases';
import Function from './components/Function';
import Order from './components/Order';
import PictureText from './components/PictureText';
import Value from './components/Value';
export default {
  components: {
    Banner,
    Function,
    Cases,
    Order,
    PictureText,
    Value,
    Appointment2
  },
  data() {
    return {
      productId: this.$productId.PC_KE_HU_DUAN.PC_JI_GOU_BAN
    };
  }
};